import classnames from 'classnames';
import collect from 'collect.js';
import { CompleteBasketItem } from '../../providers/BasketProvider';
import toFlatArray from '../../utils/to-flat.util';

interface Props {
  item: CompleteBasketItem;
  className?: string;
}

export default function BasketItemModifiers(props: Props) {
  const { item, className } = props;

  if (!item.modifiers?.length) {
    return null;
  }

  const modifiers = collect(toFlatArray(item.modifiers, 'modifiers'))
    .filter((modifier) => !!modifier)
    .implode('entry.name', ' • ');

  return <p className={classnames(modifiersStyle, className)}>{modifiers}</p>;
}

const modifiersStyle = 'break-words text-muted-foreground text-xs font-medium';
